module.exports = __webpack_public_path__ + "img/vicon7.fe7d33a3.png";